import React from "react";
import EllipsisSpan from "./EllipsisText.styled";

const EllipsisText = ({ text, maxLength = 30, className, style, onClick }) => {
  if (!text) return null;

const ellipsis = text.length > maxLength;
  const displayText = ellipsis ? `${text.substring(0, maxLength)}...` : text;

  if (ellipsis) {
    return (
        <EllipsisSpan
          className={className}
          style={style}
          onClick={onClick}
          ellipsis={ellipsis}
        >
          {displayText}
        </EllipsisSpan>
    );
  }

  return (
    <EllipsisSpan
      className={className}
      style={style}
      onClick={onClick}
      ellipsis={ellipsis}
    >
      {displayText}
    </EllipsisSpan>
  );
};

export default EllipsisText;
